import {Client} from "../internal/model/client_model";

export class RlMediaStream {
    /** @internal */
    private readonly _client: Client;
    /** @internal */
    private readonly _trackId: string;
    /** @internal */
    private readonly _mediaStream: MediaStream;

    /** @internal */
    protected get Stream(): MediaStream {
        return this._mediaStream;
    }

    public get Client(): Client {
        return this._client;
    }

    public get TrackId(): string {
        return this._trackId;
    }

    constructor(client: Client, trackId: string, mediaStream: MediaStream) {
        this._client = client;
        this._trackId = trackId;
        this._mediaStream = mediaStream;
    }
}